import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import { PrimaryActionButton } from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import {
  useNextUpReviewContext,
} from 'Views/Page/Content/Modal/Layouts/FacetPlanProposalNextUpReview/Layout/Components/NextUpContext';
import useMountedGuard from 'Hooks/useMountedGuard';

const useStyles = buildUseStyles('DialogActions', (() => ({
  root: {},
})));

const DialogActions = () => {
  const classes = useStyles();

  const { nextUpReviewResource: resource } = useNextUpReviewContext();
  const { doWithMountedGuard } = useMountedGuard();
  const [loading, _setLoading] = React.useState(false);
  const setLoading = doWithMountedGuard(_setLoading);
  const { clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const { displayErrorMessage, displaySuccess } = useSnackbarContext();

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await resource.submit();
      await refreshPageContentCollection();
      displaySuccess('Proposal Sent to Member');
      clearModalCollection();
    } catch (e) {
      displayErrorMessage(e, e.errors);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      className={classes.root}
    >
      <CenteredActions>
        <PrimaryActionButton
          onClick={handleSubmit}
          loading={loading}
          disabled={loading}
          size="lg"
          label={'Send to Member'}
        />
      </CenteredActions>
    </Box>
  );
};

export default DialogActions;
